import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  inject,
  OnInit,
} from "@angular/core";
import { Subscription } from "rxjs";
import { DualCommunicatorService } from "../../services/internal-services/dual-communicator.service";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { IViewerconfiguration } from "../../interfaces/i-viewerconfiguration";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { MapService } from "../../services/internal-services/map.service";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";
import { ViewerConfigurationService } from "../../services/viewer-configuration.service";

interface Unit {
  value: string;
  viewValue: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-scale-bar",
  templateUrl: "./scale-bar.component.html",
  styleUrls: ["./scale-bar.component.scss"],
  standalone: false,
})
export class ScaleBarComponent implements AfterViewChecked, AfterViewInit, OnInit {
  subscriptions: Subscription[] = [];

  scaleLine: any;

  width: string;

  mapIndex: number;

  _unitSelected: string;

  viewerService = inject(VIEWER_SERVICE);

  viewerConfigurationService = inject(ViewerConfigurationService);

  units: Unit[] = [
    {
      value: ViewerConstants.MEASUREMENT_SYSTEMS.SYSTEMS[1].NAME.toLowerCase(),
      viewValue: "imperial",
    },
    {
      value: ViewerConstants.MEASUREMENT_SYSTEMS.SYSTEMS[0].NAME.toLowerCase(),
      viewValue: "metric",
    },
  ];

  @Input()
  set unitSelected(unit: string) {
    this._unitSelected = unit;
    if (this.scaleLine) {
      this.scaleLine.setUnits(this.unitSelected);
    }
  }

  @Input()
  discreteEnabled: boolean;

  @Input()
  set viewerConfiguration(viewerConfiguration: IViewerconfiguration) {
    if (viewerConfiguration && viewerConfiguration.measureSystem && !this.dualService.isDualEnabled()) {
      this.unitSelected = viewerConfiguration.measureSystem.toLowerCase();
      this.dualService.changeUnitSelected(this.unitSelected);
    }
  }

  constructor(
    private mapService: MapService,
    protected toolbarService: ToolbarService,
    private dualService: DualCommunicatorService,
  ) {}

  ngOnInit(): void {
    this.mapIndex = this.mapService.getMapIndex();
  }

  get unitSelected(): string {
    return this._unitSelected;
  }

  ngAfterViewInit() {
    if (this.dualService.isDualEnabled()) {
      this.unitSelected = this.dualService.unitSelectedSubject.getValue();
    }
    this.subscriptions.push(
      this.viewerConfigurationService.globalMeasurementSystem$.subscribe((system) => {
        if (system === ViewerConstants.MEASUREMENT_SYSTEMS.IDS.METRIC) {
          this.unitSelected = "metric";
        } else if (system === ViewerConstants.MEASUREMENT_SYSTEMS.IDS.IMPERIAL) {
          this.unitSelected = "imperial";
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  ngAfterViewChecked() {
    if (!this.discreteEnabled) {
      if (this.mapService.getCoreMap() && !this.scaleLine) {
        this.scaleLine = this.mapService.getCoreMap().scaleControl;
        this.scaleLine?.setUnits(this.unitSelected);
      }
    }
  }

  onChangeUnit(unit: string) {
    this.unitSelected = unit;
    this.dualService.changeUnitSelected(this.unitSelected);
    if (this.scaleLine) {
      this.scaleLine.setUnits(this.unitSelected);
    }
  }
}
